<!--
 * @Author: Jason
 * @Date: 2019-08-01 12:38:07
 * @version:
 * @LastEditors: Jason
 * @LastEditTime: 2019-10-29 16:31:53
 * @Descripttion:
 -->
<template>
    <div>
        <v-head :isShowBack="$route.meta.isShowIcon" >{{headTille}}</v-head>
        <div class="mt order-result" v-if="TkStatus">
          <div class="prder-result-info">
            <div class="order-result-title">恭喜您获得洗车券</div>
            <div class="flex-jcc order-result-qrcode">
                <img src="../../assets/imgs/suncar.png" alt="">
                <qrcode-vue :size="qrcodeSize" :value="orderInfo.orderImg || orderInfo.matrixContent" level="H"></qrcode-vue>
            </div>
            <div class="order-info-list">
                <div class="flex-btwn-aic order-info-item">
                    <div>订单串码：</div>
                    <div>{{orderInfo.orderId}}</div>
                </div>
                <div class="flex-btwn-aic order-info-item">
                    <div>有效期至：</div>
                    <div>{{orderInfo.endTime}}</div>
                </div>
            </div>
            <div class="order-btn-list">
                <div class="order-btn-item bg" @click="toRouter('/shop/city')">查看服务门店</div>
                <div class="order-btn-item border" @click="toRouter('/home')">返回首页</div>
            </div>
          </div>
            <div class="img-box">

              <img src="../../assets/imgs/service_tip.png" alt="">
            </div>
        </div>
        <div class="mt order-result" v-else>
          <img src="../../assets/imgs/errorImg.png" alt="">
          <p style="color: #999999;margin-bottom:60px;">发券失败。当前支付仅限农业银行信用卡支付，付款金额及权益稍后会原路退回，如2个小时内未收到退款，请联系客服处理4008881768！</p>

            <div class="order-btn-list">
                <div class="order-btn-item bg" @click="toRouter('/shop/city')">查看服务门店</div>
                <div class="order-btn-item border" @click="toRouter('/home')">返回首页</div>
            </div>
        </div>

    </div>
</template>
<script>
import QrcodeVue from 'qrcode.vue';
import vHead from "@/components/vHead.vue";
import { GetOrderQuery } from "@/api/order.js";
import { ls,ISWX } from "@/assets/js/utils.js";
export default {
    components: {
      vHead,
      QrcodeVue
    },

    data() {
        return {
          qrcodeSize: 160,
          orderInfo:{},
          headTille:"支付成功",
          TkStatus:true

        };
    },
    mounted(){
      // let _ = this
      document.body.style.backgroundColor = '#F4F5F7'
    },
    created(){

      let _ = this
        _.getOrderDetail()
      console.log("是否微信内",ISWX())
      if(ISWX()){
        _.getOrderDetail()
      }else{
        _.orderInfo = _.$route.query
        console.log("地址栏获取到的信息",_.orderInfo)
      }

    },
    methods:{
      getOrderDetail(){
        let _ = this
        let pars = {
          orderId:_.$route.params.id,
          token:ls.getter("loginStatus")
        }
        GetOrderQuery(pars).then(res=>{

          _.orderInfo = res.list.length>0 ? res.list[0] : {}

          if(res.list[0].status == 7){
            _.headTille="",
            _.TkStatus=false
          }else{
            _.headTille="支付成功",
            _.TkStatus=true
          }
        }).catch(err=>{
          if(err&&err.resultDes){
            _.toast(err.resultDes)
          }
        })
      },
      toRouter(val){
        let _ = this
        if(val == '/home'){
          _.$router.replace(val)
        }else{
          _.$router.push(val)
        }

      },
    }
}
</script>
<style lang="scss" scoped>
.order-tip{
  text-align: center;
  margin-top:1.6667vw;
}
.order-title{
  text-align: center;
  font-size: 6vw;
}
.order-img{
  width: 50%;
  margin:4vw auto 0;
}
.order-result{
  padding: 6vw 10%;
  .prder-result-info{
    background-color: #fff;
    padding: 8vw 4vw 0;
    border-radius: 2vw;
    margin-bottom: 4vw;
  }
  .order-result-title{
    font-size: 4.2667vw;
    color: #FF5F00;
    text-align: center;
    font-weight: bold;
    // margin: 8vw 0 6vw;
  }
  .order-result-qrcode{
    margin-top: 6vw;
    position: relative;
    img{
      width: 12vw;
      height: 12vw;
      position: absolute;
      top: 50%;
      margin-top: -6vw;
      left: 50%;
      margin-left: -6vw;
    }
  }
  .order-info-list{
    margin: 6vw -4vw 0;
    border-top: 1px dashed #999;
    .order-info-item{
      width: 100%;
      height: 12vw;
      padding: 0 4vw;
    }
  }
  .order-btn-list{
    padding: 4vw 0 6vw;
    .order-btn-item{
      width: 100%;
      height: 13.3333vw;

      border-radius: 2vw;
      text-align: center;
      line-height: 13.3333vw;
      &.bg{
        background-color: #16A085;
        color: #fff;
      }
      &.border{
        margin-top: 6vw;
        border: 1px solid #16A085;
        color: #16A085;
      }
    }
  }
}

</style>


